import { Link } from '@tanstack/react-router';
import { Skeleton, Text, VStack } from 'ui_2';
import { ArcadeStoreRewardRow } from './ArcadeStoreRewardRow';
import { Route as rewards_route } from '@routes/rewards';
import { Route as reward_route } from '@routes/reward';
import { useRewards } from '@src/hooks/useArcadeStore';
import { useMemo } from 'react';
import { useViewTransition } from '@src/hooks/useViewTransition';

export const ArcadeStoreRewardRows = () => {
  const { slideLeftFullPage } = useViewTransition();
  const { data: rewards, error, isLoading } = useRewards();

  const { availableRewards, redeemedRewards } = useMemo(() => {
    if (rewards === undefined) {
      return {
        availableRewards: undefined,
        redeemedRewards: undefined,
      };
    }
    const availableRewards = rewards.filter((reward) => reward.used === false);
    const redeemedRewards = rewards.filter((reward) => reward.used === true);
    return {
      availableRewards,
      redeemedRewards,
    };
  }, [JSON.stringify(rewards)]);

  if (rewards?.length === 0) {
    return (
      <VStack className='w-full items-center'>
        <Text>You have no purchases yet.</Text>
      </VStack>
    );
  } else if (isLoading) {
    return (
      <VStack className={`grid w-full gap-4`}>
        {[...Array(4).keys()].map((_, ix) => (
          <Skeleton className='h-[62px]' delay={ix} key={ix} />
        ))}
      </VStack>
    );
  } else if (error) {
    return (
      <VStack className='w-full items-center'>
        <Text>Error loading your purchases!</Text>
        <Text>{error.message}</Text>
      </VStack>
    );
  } else if (rewards === undefined) {
    console.error('Rewards is undefined!');
    return (
      <VStack className='w-full items-center'>
        <Text>Purchases is somehow undefined...</Text>
      </VStack>
    );
  }

  return (
    <VStack className={`gap-4 pb-8`}>
      {availableRewards && availableRewards.length > 0 && (
        <VStack className='gap-2'>
          <Text font='medium-md'>Available Items</Text>
          {availableRewards?.map((reward, ix) => (
            <Link
              to={reward_route.to}
              from={rewards_route.fullPath}
              search={{
                id: reward._id,
                skuTitle: reward.productSKU.title,
                showHeader: true,
                showAccountAndBalance: true,
              }}
              key={ix}
              viewTransition={slideLeftFullPage}
            >
              <ArcadeStoreRewardRow reward={reward} key={ix} />
            </Link>
          ))}
        </VStack>
      )}
      {redeemedRewards && redeemedRewards.length > 0 && (
        <VStack className='gap-2'>
          <Text font='medium-md'>Used Items</Text>
          {redeemedRewards?.map((reward, ix) => (
            <Link
              to={reward_route.to}
              search={{
                id: reward._id,
                skuTitle: reward.productSKU.title,
                showHeader: true,
                showAccountAndBalance: true,
              }}
              key={ix}
              viewTransition={slideLeftFullPage}
            >
              <ArcadeStoreRewardRow reward={reward} key={ix} />
            </Link>
          ))}
        </VStack>
      )}
    </VStack>
  );
};
